import { DeliveryEstimate } from "@redotech/redo-model/conversion/conversion-autocheck";
import { InsertionPosition } from "@redotech/redo-model/widget";
import { useMemo } from "react";
import { log } from "../../monitoring/log";
import { RedoDeliveryEstimateContainerElement } from "./element";

const positionMap: Record<InsertionPosition, InsertPosition> = {
  [InsertionPosition.BEFORE]: "beforebegin",
  [InsertionPosition.AFTER]: "afterend",
  [InsertionPosition.PREPEND]: "afterbegin",
  [InsertionPosition.APPEND]: "beforeend",
};

type PdpPortal = {
  foundSelector?: string;
  portal: RedoDeliveryEstimateContainerElement;
};

export const PRODUCT_PAGE_DELIVERY_ESTIMATE_CONTAINER_ID =
  "redo-delivery-estimate-container";
export const STYLE_DISPLAY_UNSET = "unset !important";

export function useRenderPdps({
  deliveryEstimate,
}: {
  deliveryEstimate: DeliveryEstimate;
}): PdpPortal[] {
  const renderPdps = useMemo(() => {
    const pdps: PdpPortal[] = [];

    // For theme extensions, use the configured selectors
    log(
      "delivery estimate pdpSelectors (theme extension)",
      deliveryEstimate.pdpSelectors,
    );

    // Register the custom element if not already registered
    RedoDeliveryEstimateContainerElement.register();

    for (const selectorConfig of deliveryEstimate.pdpSelectors) {
      const containers = document.querySelectorAll(selectorConfig.selector);
      log(
        `delivery estimate containers for selector "${selectorConfig.selector}"`,
        containers,
      );

      for (const container of containers) {
        const pdpElement = document.createElement(
          RedoDeliveryEstimateContainerElement.TAG,
        ) as RedoDeliveryEstimateContainerElement;
        pdpElement.id = PRODUCT_PAGE_DELIVERY_ESTIMATE_CONTAINER_ID;
        pdpElement.style.display = STYLE_DISPLAY_UNSET;

        const insertPosition = positionMap[selectorConfig.insertPosition];
        container.insertAdjacentElement(insertPosition, pdpElement);

        pdps.push({
          foundSelector: selectorConfig.selector,
          portal: pdpElement,
        });
      }
    }

    return pdps;
  }, [deliveryEstimate]);

  return renderPdps;
}
